<template>
  <teleport to="body">
    <app-registration
      v-if="shouldShowNftPreview"
      :closeButton="true"
      :returnToPreviousModal="close"
    >
      <template v-slot:app-modal-body>
        <div class="app-modal-body-wrapper">
          <img
            src="@/Common/Icons/theos_logo.png"
            alt="Logo"
            class="logo-gif"
          />
          <p class="app-modal-welcome-text">NFT Preview</p>
          <img id="preview-image" :src="previewSrc" alt="Preview" />
          <div class="audio-preview-in-modal" v-if="audioSrc">
            <app-audio :url="audioSrc"></app-audio>
          </div>
          <div class="preview-description">
            <p class="preview-title">
              {{ name
              }}<span class="video-time" v-show="isVideo"
                >{{ convertTimeHHMMSS(videoDuration) }} min</span
              >
            </p>
            <p class="preview-text">{{ description }}</p>
          </div>
          <hr class="preview-horizontal" />
          <div class="preview-description">
            <p class="preview-text">Tags</p>
            <ul>
              <li class="preview-tag" v-for="(tag, index) in tags" :key="index">
                {{ tag }}
              </li>
            </ul>
          </div>
          <hr class="preview-horizontal" />
          <div class="preview-royalties-wrapper">
            <div class="preview-royalties">
              <p class="preview-text">Royalties</p>
              <span class="royalties">{{ royalties || 0 }}%</span>
            </div>
          </div>
          <div v-if="shouldShowRoyaltyButton" class="set-royalties-text">
            <p style="text-align: center">
              If you wish royalties to be set for your NFT,
            </p>
            <p style="text-align: center">
              You must first Create Royalty and then Create NFT
            </p>
            <div class="app-modal-button-controls">
              <app-button
                @click="royaltyButton()"
                buttonClass="app-modal-button-inverse"
                buttonStyle="width: 100%"
                text="Create Royalty"
                type="submit"
              />
            </div>
          </div>
          <div class="app-modal-button-controls-preview-modal">
            <app-button
              @click="createButton()"
              buttonClass="app-modal-button-inverse"
              text="Create"
              type="submit"
            />
            <app-button
              @click.prevent="backButton()"
              buttonClass="app-modal-button"
              text="Back"
            />
          </div>
        </div>
        <div class="footer-gradient-background"></div>
      </template>
    </app-registration>
    <app-registration
      v-if="isMinting"
      :closeButton="true"
      :returnToPreviousModal="returnToProfile"
    >
      <template v-slot:app-modal-body>
        <div class="app-modal-body-wrapper">
          <loader :isGreen="true" />
          <p class="app-modal-minting-text">MINTING</p>
          <p class="app-modal-info-text">
            Sending transaction to create your NFT...
          </p>
        </div>
      </template>
    </app-registration>
    <app-registration
      v-if="isMintingFinished"
      :closeButton="true"
      :returnToPreviousModal="redirectToProfilePage"
    >
      <template v-slot:app-modal-body>
        <div class="app-modal-body-wrapper">
          <img src="@/Common/Icons/LOGO_GIF.gif" alt="Logo" class="logo-gif" />
          <div class="congrats">
            <p class="app-modal-congrats-text">Congratulations!</p>
            <p class="app-modal-description-text">
              {{ name }} has been succesfully created
            </p>
            <p class="app-modal-description-text">
              and is already featured on Theos platform!
            </p>
          </div>
          <img id="preview-image" :src="previewSrc" alt="Preview" />
          <div class="audio-preview-in-modal" v-if="audioSrc">
            <app-audio :url="audioSrc"></app-audio>
          </div>
          <div class="preview-description">
            <p class="preview-title">{{ name }}</p>
            <p class="preview-text">{{ description }}</p>
          </div>
          <hr class="preview-horizontal" />
          <div class="preview-description">
            <p class="preview-text">Tags</p>
            <ul>
              <li class="preview-tag" v-for="(tag, index) in tags" :key="index">
                {{ tag }}
              </li>
            </ul>
          </div>
          <hr class="preview-horizontal" />
          <div class="preview-royalties-wrapper">
            <div class="preview-royalties">
              <p class="preview-text">Royalties</p>
              <span class="royalties">{{ royalties || 0 }}%</span>
            </div>
          </div>
          <div class="app-modal-button-controls">
            <app-button
              @click="viewInCardanoscan()"
              buttonClass="app-modal-button"
              text="View on Cardanoscan"
            />
            <div class="share-popup-box">
              <div class="share-icon" v-if="showShare">
                <p class="share-popup-text">Share my NFT</p>
                <div class="icons-wrapper">
                  <ShareNetwork
                    v-for="network in networks"
                    :network="network.network"
                    :key="network.network"
                    :url="`${url}/nft-details/${mintedNft.id}`"
                    :title="sharing.title"
                    :description="sharing.description"
                    :quote="sharing.quote"
                    :hashtags="sharing.hashtags"
                    :twitterUser="sharing.twitterUser"
                    @click="analytics(network.name)"
                  >
                    <span class="icon-for-share"
                      ><img :src="network.icon" :alt="network.name"
                    /></span>
                  </ShareNetwork>
                  <span
                    ><img
                      class="copy-link"
                      src="@/Common/Icons/Copy2.png"
                      alt="Share"
                      @click="
                        copyToClipboard(`${url}/nft-details/${mintedNft.id}`)
                      "
                  /></span>
                </div>
              </div>
              <app-button
                @click="shareMyNft()"
                buttonClass="app-modal-button-inverse"
                text="Share my NFT"
              />
            </div>
          </div>
        </div>
      </template>
    </app-registration>
  </teleport>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Loader from "@/elements/AppLoader.vue";
import AppAudio from "@/components/AppAudio";
import AppButton from "@/elements/AppButton";
import useMinting from "@/composables/useMinting";
import AppRegistration from "@/elements/AppRegistration";
import useUtilities from "@/composables/useUtilities";
import useGoogleTag from "@/composables/useGoogleTag";

export default {
  components: {
    AppRegistration,
    AppButton,
    AppAudio,
    Loader,
  },
  props: {
    txHash: {
      type: String,
    },
    handleSubmit: {
      type: Function,
    },
    handleRoyalty: {
      type: Function,
    },
  },
  setup(props) {
    const store = useStore();
    const {
      name,
      tags,
      isMinting,
      royalties,
      description,
      setIsMinting,
      selectedFile,
      coverImageFile,
      showNftPreview,
      hideNftPreview,
      showRoyaltyButton,
      hideRoyaltyButton,
      isMintingFinished,
      showMintNftStepper,
      shouldShowNftPreview,
      shouldShowRoyaltyButton,
    } = useMinting(store);

    if (royalties.value == 0 || royalties.value == null) {
      console.log("royalties", royalties);
      console.log("royalties.value", royalties.value);
      hideRoyaltyButton();
    } else {
      showRoyaltyButton();
    }
    const { registerEvent } = useGoogleTag();
    const url = ref(process.env.VUE_APP_BASE_PATH);
    const mintedNft = computed(() => store.getters["nfts/getNftData"]);
    const previewSrc = ref("");
    const audioSrc = ref("");
    const videoDuration = ref(0);
    const isVideo = ref(false);
    const showShare = ref(false);
    const fileType = (file) => file.type?.split("/")[0];
    const makeUrl = (file) => URL.createObjectURL(file);
    const { copyToClipboard } = useUtilities();
    const router = useRouter();
    const sharing = ref({
      title: "I've just minted an NFT through Theos",
      description: "",
      quote: "",
      hashtags: "theos",
      twitterUser: "theosfi",
    });
    const networks = ref([
      {
        network: "twitter",
        name: "Twitter",
        icon: require(`@/Common/Icons/Twitter.png`),
      },
      {
        network: "telegram",
        name: "Telegram",
        icon: require(`@/Common/Icons/Telegram.png`),
      },
      {
        network: "reddit",
        name: "Reddit",
        icon: require(`@/Common/Icons/Reddit.png`),
      },
    ]);
    previewSrc.value = coverImageFile.value.type
      ? makeUrl(coverImageFile.value)
      : makeUrl(selectedFile.value);

    audioSrc.value =
      fileType(selectedFile.value) === "audio"
        ? makeUrl(selectedFile.value)
        : "";

    const getVideoDuration = (file) => {
      let videoUrl = URL.createObjectURL(file);
      let audioElement = new Audio(videoUrl);
      audioElement.onloadedmetadata = () => {
        videoDuration.value = parseInt(audioElement.duration);
      };
    };

    if (fileType(selectedFile.value) === "video") {
      getVideoDuration(selectedFile.value);
      isVideo.value = true;
    }

    const convertTimeHHMMSS = (val) => {
      let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
      return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
    };

    const backButton = () => showMintNftStepper();

    const createButton = () => {
      hideNftPreview();
      setIsMinting(true);
      props.handleSubmit();
    };

    const royaltyButton = () => {
      hideNftPreview();
      setIsMinting(true);
      props.handleRoyalty();
    };

    const returnToPreviousModal = () => {
      showNftPreview();
      setIsMinting(false);
    };
    const returnToProfile = async () => {
      await router.push("/profile");
      setIsMinting(false);
    };

    const close = () => {
      showMintNftStepper();
    };

    const redirectToProfilePage = () => {
      store.dispatch("minting/resetState");
      store.dispatch("tagsValues/resetState");
      router.push({ path: "/profile" });
    };
    // const viewInPolygonscan = () => {
    //   window.open(`${process.env.VUE_APP_EXPLORER_URL}/tx/${props.txHash}`);
    // };
    const viewInCardanoscan = () => {
      window.open(
        `${process.env.VUE_APP_EXPLORER_URL}/transaction/${props.txHash}`
      );
    };
    const shareMyNft = () => (showShare.value = !showShare.value);

    const analytics = (name) => {
      registerEvent(`nft shared on ${name}`);
    };
    return {
      name,
      tags,
      close,
      makeUrl,
      audioSrc,
      fileType,
      royalties,
      previewSrc,
      backButton,
      description,
      createButton,
      royaltyButton,
      selectedFile,
      coverImageFile,
      redirectToProfilePage,
      videoDuration,
      isVideo,
      shareMyNft,
      showShare,
      showRoyaltyButton,
      convertTimeHHMMSS,
      shouldShowNftPreview,
      shouldShowRoyaltyButton,
      isMinting,
      isMintingFinished,
      viewInCardanoscan,
      returnToPreviousModal,
      sharing,
      networks,
      copyToClipboard,
      mintedNft,
      url,
      analytics,
      returnToProfile,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/previewModal.scss"></style>
